import { Sprite, TextStyle, Text } from "pixi.js";
import { CommonResourcesPackage } from "../../../common/resources/CommonResourcesPackage";
import { GameFont } from "../../../common/GameFont";
import { HBox } from "../../../common/components/ui/HBox";

export class LoyaltyCoinsContainer extends HBox {
    private static readonly LOYALTY_COINS_MULTIPLIER_TEXT = "PIGGY BOOSTER: ";
    private static readonly CHILD_SPACING = 5;

    private readonly commonResources: CommonResourcesPackage;

    private readonly loyaltyCoinsText: Text;
    private readonly multiplierText: Text;
    private readonly icon: Sprite;

    public constructor(commonResources: CommonResourcesPackage, multiplier: number) {
        super(LoyaltyCoinsContainer.CHILD_SPACING);
        this.commonResources = commonResources;
        this.loyaltyCoinsText = new Text(LoyaltyCoinsContainer.LOYALTY_COINS_MULTIPLIER_TEXT, new LoyaltyCoinsTextStyle());
        this.addChild(this.loyaltyCoinsText);
        this.icon = new Sprite(this.commonResources.assets_common_ui_piggy_icon_without_mp_png);
        this.icon.scale.set(0.9);
        this.icon.position.y = -20;
        this.addChild(this.icon);
        this.multiplierText = new Text(`+${Math.round((multiplier - 1) * 100)}%`, new MultiplierTextStyle());
        this.multiplierText.position.set(this.icon.width * 0.5 - this.multiplierText.width * 0.40 - 4, this.icon.height * 0.5 - 5);
        this.icon.addChild(this.multiplierText);
    }

    public updateMultiplier(multiplier: number): void {
        this.multiplierText.text = `+${Math.round((multiplier - 1) * 100)}%`;
    }
}

class MultiplierTextStyle extends TextStyle {
    public constructor() {
        super(new TextStyle({
            align: "center",
            fill: "#9cfbfe",
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 26,
        }));
    }
}

class LoyaltyCoinsTextStyle extends TextStyle {
    public constructor() {
        super(new TextStyle({
            align: "center",
            fill: "#ffffff",
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 40
        }));
    }
}
